import React, {useEffect, useState} from 'react';
import axios from "axios";
import { config } from "../../../../Helpers/env";
import {errorMessages} from "../../../../Helpers/ErrorMessages";


export const useEditProductSetup = (actions, component) => {
    const [debit, setDebit] = useState('')
    const [credit, setCredit] = useState('')
    const [submitted, setSubmitted] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState('idle');
    const [openEdit, setOpenEdit] = useState(false)
    const [editId, setEditId] = useState('')
    const [editData, setEditData] = useState({})
    const [credit_ledger, setLedger] = useState('')
    const [product, setProduct] = useState('')


    useEffect(() => {
        if(!editId){
            return
        }
        const formData = new FormData()
        formData.append('id', editId)
        axios.post(`${config.smsUrl}/accounting/entity_behavior/entity_update_form`, formData).then(res => {
            const data = res.data;
            const dt = data ? data : {};
            const arr = dt.data ? dt.data : {}
            const ledger = arr.credit_ledger ? arr.credit_ledger : ''
            setEditData(arr)
            setLedger(ledger)
        }).catch(err => {
            errorMessages(err, null, actions)
        })
    }, [editId])



    const handleChangeDebit = (val) => {
        setDebit(val)
    }

    const handleChangeCredit = (val) => {
        setCredit(val)
    }


    const handleOpenEdit = (id) =>{
        setOpenEdit(true)
        setEditId(id)
    }

    const handleCloseEdit = () =>{
        setOpenEdit(false)
    }
    const handleEditLedger = (event) => {
        event.preventDefault();
        setSubmitted(true);
        const credit_val  = credit ? credit: {};
        const credit_value = credit_val.value ? credit_val.value : ''
        const debit_val  = debit ? debit : {};
        const debit_value = debit_val.value ? debit_val.value : '';
        const formData = new FormData();
        formData.append('id',editId)
        formData.append('credit_ledger',credit_value)
        formData.append('debit_ledger',debit_value)
        formData.append('entity_type',component)
        setIsSubmitted('pending');
        axios.post(`${config.smsUrl}/accounting/entity_behavior/edit`,formData).then(() => {
            actions.snackbarActions.snackSuccess('Entry edit successfully')
            setIsSubmitted('resolved')
            // setCredit('')
            // setDebit('')
            setSubmitted(false)
            setOpenEdit(false)
        }).catch(err => {
            errorMessages(err, null, actions)
            setIsSubmitted('rejected')
        })
     
    }



    const isPendingEdit = isSubmitted === 'pending'
    const isResolvedEdit = isSubmitted === 'resolved'
    const isRejectedEdit = isSubmitted === 'rejected'

    const editProps = {editData, credit, debit,handleChangeCredit, handleChangeDebit,
        handleEditLedger, isPendingEdit, isRejectedEdit, isResolvedEdit, submitted, value:product
    }


    return {editProps,openEdit, handleCloseEdit, handleOpenEdit,
        credit_ledger, editData,setCredit,setDebit, setProduct}
}